import { Box, TableRow } from '@mui/material';

import { UserAvatar } from 'user/components/UserAvatar';
import { TableCell } from 'common/components/Table';
import { Checkbox } from 'common/components/Checkbox';
import { IUserListItemFragment } from 'graphql/types';
import { Typography } from 'common/components/Typography';
import { IGlobalDrawerType } from 'common/types';
import { useGlobalDrawer } from 'common/hooks/useGlobalDrawer';

interface IProps {
    disabled?: boolean;
    isEditable?: boolean;
    isSelectable?: boolean;
    isSelected?: boolean;
    trainer: IUserListItemFragment;
    onSelect?(): void;
}

export const TrainerTableRow = ({
    disabled,
    isEditable = true,
    isSelectable = true,
    isSelected,
    trainer,
    onSelect,
}: IProps) => {
    const { openGlobalDrawer } = useGlobalDrawer();

    const { id, name } = trainer;

    const isDisabled = !isEditable || disabled;

    return (
        <TableRow
            hover
            sx={{
                cursor: !isDisabled && isSelectable ? 'pointer' : 'unset',
            }}
        >
            {isSelectable && (
                <TableCell>
                    {isEditable ? (
                        <Checkbox
                            checked={isSelected}
                            disabled={isDisabled}
                            onClick={(e) => {
                                onSelect?.();

                                e.stopPropagation();
                            }}
                        />
                    ) : (
                        <Checkbox disabled checked={false} />
                    )}
                </TableCell>
            )}

            <TableCell
                sx={{ cursor: 'pointer' }}
                onClick={() => {
                    openGlobalDrawer({
                        type: IGlobalDrawerType.UserProfile,
                        itemId: id,
                    });
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <UserAvatar size={45} user={trainer} />

                    <Box sx={{ ml: 2 }}>
                        <Typography
                            color={isDisabled ? 'grey.500' : undefined}
                            variant="body2"
                        >
                            {name}
                        </Typography>
                    </Box>
                </Box>
            </TableCell>
        </TableRow>
    );
};
